// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"

// Highlighting for code blocks
import "prismjs/themes/prism.css"

const {createAnalytics} = require('./src/utils/analytics')
const pageView = createAnalytics()
export const onRouteUpdate = ({location}) => {
  // Helmet updates the document title during the navigation render.
  window.requestAnimationFrame(() => pageView(window, location, document.title))
}
